// src/api/OrderExecutionEngine.jsx - V8.0 (SINCRO TOTAL)
import apiClient from './apiClient';

export const OrderExecutionEngine = {
    /**
     * 📡 LISTAR NOVOS (PENDENTES)
     * Usada na triagem inicial do hangar.
     */
    listarNovos: async () => {
        try {
            const response = await apiClient.get('/api/orders-intel/status/PENDENTE');
            // Retorna o array de dados limpo
            return response.data?.data || response.data || [];
        } catch (err) {
            console.error("🚩 [ENGINE]: Falha ao listar pendentes.");
            return [];
        }
    },

    listarHistorico: async () => {
        try {
            // Busca CONCLUIDO e CANCELADO em paralelo
            const [concluidos, cancelados] = await Promise.all([
                apiClient.get('/api/orders-intel/status/CONCLUIDO'),
                apiClient.get('/api/orders-intel/status/CANCELADO')
            ]);
            
            const listC = Array.isArray(concluidos.data?.data || concluidos.data) ? (concluidos.data?.data || concluidos.data) : [];
            const listX = Array.isArray(cancelados.data?.data || cancelados.data) ? (cancelados.data?.data || cancelados.data) : [];
            
            return [...listC, ...listX];
        } catch (err) {
            console.error("🚩 [ENGINE]: Falha ao buscar histórico.");
            return [];
        }
    },

    /**
     * 🛰️ WAR ROOM: Reconhecimento 360º
     */
    obterQuadroOperacoes: async () => {
        try {
            const [activeRes, pendingRes, completedRes, cancelledRes, summaryRes] = await Promise.all([
                apiClient.get('/api/orders-intel/active'),
                apiClient.get('/api/orders-intel/status/PENDENTE'),
                apiClient.get('/api/orders-intel/status/CONCLUIDO'),
                apiClient.get('/api/orders-intel/status/CANCELADO'),
                apiClient.get('/api/order-board/summary')
            ]);

            const activeList = Array.isArray(activeRes.data) ? activeRes.data : [];
            const pendingList = Array.isArray(pendingRes.data) ? pendingRes.data : [];
            const completedList = Array.isArray(completedRes.data) ? completedRes.data : [];
            const cancelledList = Array.isArray(cancelledRes.data) ? cancelledRes.data : [];
            const summaryRaw = summaryRes.data?.data || {};
            const summaryList = Object.values(summaryRaw).flat();

            const masterMap = new Map();
            [...activeList, ...pendingList, ...completedList, ...cancelledList, ...summaryList].forEach(order => {
                if (order && order._id) masterMap.set(order._id, order);
            });

            return {
                success: true,
                data: {
                    PENDENTE: pendingList,
                    ACTIVE_FULL: activeList,
                    CONCLUIDO: completedList,
                    CANCELADO: cancelledList,
                    GOD_VIEW: Array.from(masterMap.values())
                }
            };
        } catch (error) {
            console.error("🚩 [ENGINE]: Falha na infiltração de dados.");
            return { success: false, data: { PENDENTE: [], ACTIVE_FULL: [], CONCLUIDO: [], GOD_VIEW: [] } };
        }
    },

    /**
     * 🎖️ ATRIBUIÇÃO E ATUALIZAÇÃO
     */
    atualizarStatus: async (orderId, newStatus, comentario, cat, sub, dataConclusao) => {
        try {
            const response = await apiClient.put(`/api/orders-intel/${orderId}/status`, { 
                status: newStatus,
                comentario,
                categoriaInterna: cat,
                subCategoriaInterna: sub,
                dataConclusao
            });
            return response.data?.success || false;
        } catch (error) { return false; }
    },

    atribuirPedido: async (orderId, brokerId) => {
        try {
            // Sincronizado com o endpoint de assign do Intel
            const response = await apiClient.put(`/api/orders-intel/${orderId}/assign`, { brokerId });
            return response.data?.success || false;
        } catch (error) { return false; }
    },

    gerarNovoToken: async (orderId) => {
        try {
            const response = await apiClient.put(`/api/orders-intel/${orderId}/generate-token`);
            return response.data; 
        } catch (error) { return { success: false }; }
    },

    verificarRastreio: async (token, identifier) => {
        try {
            const response = await apiClient.post('/api/order-tracking/verify', { 
                token, identifier: identifier.replace(/\D/g, '') 
            });
            return response.data; 
        } catch (error) { return { success: false }; }
    },
    
    criarPedidoManual: async (orderData) => {
        try {
            // Chama a nova rota POST no backend
            const response = await apiClient.post('/api/pedidos/manual', orderData);
            return response.data?.success ? response.data.data : false;
        } catch (error) {
            console.error("🚩 [ENGINE]: Falha ao criar pedido manual.", error);
            return false;
        }
    }
};